import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/data/site";

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-forest/15 bg-cream py-10 md:py-14"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {MARQUEE_WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-serif text-4xl italic tracking-tight text-forest md:px-14 md:text-6xl">
              {w}
            </span>
            <span className="text-2xl text-sage md:text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
